import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null); // 'admin' or 'user'
  const [sessionAccess, setSessionAccess] = useState(null);
  const [divisionAuthorized, setDivisionAuthorized] = useState(null); // null = loading, true = GIL, false = non-GIL

  return (
    <UserContext.Provider value={{ user, setUser, role, setRole, sessionAccess, setSessionAccess, divisionAuthorized, setDivisionAuthorized }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};